import { render } from "./SubmitButtonComponent.vue?vue&type=template&id=450cc1c0"
import script from "./SubmitButtonComponent.vue?vue&type=script&lang=js"
export * from "./SubmitButtonComponent.vue?vue&type=script&lang=js"
script.render = render

export default script